import script from "./CouponCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponCardModal.vue?vue&type=script&setup=true&lang=js"

import "./CouponCardModal.vue?vue&type=style&index=0&id=c923eeae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c923eeae"]])

export default __exports__